// MX 墨西哥城，CR 圣何塞
const data = {
  'JP': {
    cityId: 81400100, 
    address: "日本、福岡県",
    addressAll: "福冈市, 日本、福岡県",
    addressAllDisplay: "日本、福岡県",
    city: "福岡県",
    coordinateType: "wgs84",
    countryCode: "JP",
    countryId: 81,
    countyGroupId: 814001000001,
    countyId: 81400114,
    displayName: "福冈市",
    lat: 33.5901838,
    lng: 130.4016888,
    poiId: "ChIJKYSE6aHtQTURg4c5NplyCvY",
    poiSrcTag: "manual_sug",
    poiType: "",
    searchId: "0a9e23de61c2c08e176d3b6a12828e02",
    srcTag: "geocode",
  },
  'MX':{
    poiId: "ChIJrVSd_ib_0YURoClucX-EluA",
    addressAllDisplay: "Calle Dr Martínez del Río 95, Doctores, Cuauhtémoc, 06720 Ciudad de México, CDMX, México",
    city: "Ciudad de México",
    cityId: 52090100,
    countryCode: "MX",
    countryId: 52,
    lat: 19.417612,
    lng: -99.1486205,
    displayName: "Calle Dr Martínez del Río, 95",
    address: "Calle Dr Martínez del Río 95, Doctores, Cuauhtémoc, 06720 Ciudad de México, CDMX, México",
    addressAll: "Calle Dr Martínez del Río 95, Doctores, Cuauhtémoc, 06720 Ciudad de México, CDMX, México",
    coordinateType: "wgs84",
    poiSrcTag: "manual_rgeo",
    srcTag: "reversegeotop",
    searchId: "c0a82bdf6287634e5f0fbdbf108d0303",
    distStr: "17m",
    poiType: "premise",
    countyId: 52090114,
    countyGroupId: 520901000001
  },
  'CR':{
    poiId: "ChIJxRUNxULjoI8RgrgRn2pqdOY",
    addressAllDisplay: "San José, Costa Rica",
    city: "San José",
    cityId: 506070100,
    countryCode: "CR",
    countryId: 506,
    lat: 9.9280694,
    lng: -84.0907246,
    displayName: "圣何塞",
    address: "San José, Costa Rica",
    addressAll: "圣何塞, San José, Costa Rica",
    coordinateType: "wgs84",
    poiSrcTag: "manual_sug",
    distStr: "167m",
    poiType: "locality;political;geocode",
    countyId: 506070144,
    countyGroupId: 5060701000001
  }
}

class DefaultPoi {
  constructor(option){
    const {data, defaultRegion = 'MX'} = option
    this.data = data,
    this.defaultRegion = defaultRegion
  }
  getPoi(region) {
    return this.data[region] || this.data[this.defaultRegion]
  }
}

const defaultPoi = new DefaultPoi({
  data,
  defaultRegion:'MX'
})

export default defaultPoi